import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { FullPageLoading } from '../components/FullPageLoading';
import { useAuth } from '../hooks/useAuth';
import { getReturnToFromLoginLocation } from '../lib/auth/navigation';

function LoginPage() {
  const { login, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Capturar rota de origem passada pelo ProtectedRoute via state.
  // Fallback: usa a URL atual do browser (útil após redirects externos como Google OAuth,
  // onde o state do React Router é perdido no reload completo da página).
  const from = getReturnToFromLoginLocation(location);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      login(undefined, from);
    }
  }, [isLoading, isAuthenticated, login, from]);

  if (!isLoading && isAuthenticated) {
    return <Navigate to={from || '/app'} replace />;
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-4">
      <FullPageLoading message="Redirecionando para login..." />
    </div>
  );
}

export default LoginPage;
